import logo from "../../../assets/images/needle_in_the_haystack_consumer_logo_mark.svg";

const Logo = () => {
  return (
    <div className="flex items-center justify-center w-20 h-20 rounded-full z-10">
      <img src={logo} alt="logo" className="w-10 h-10" />
    </div>
  );
};

export default Logo;
